import React from "react";
import { useAuth } from "../../context/AuthContext";
import { PageLayout } from "../PageLayout/PageLayout";
import { HttpErrorPage } from "../../pages/ErrorPages/HttpErrorPage";

export const AppNotFoundRoute: React.FC = () => {
  const { auth } = useAuth();
  const isLoggedIn = !!auth?.user;

  if (isLoggedIn) {
    return (
      <PageLayout isErrorComponent={true}>
        <HttpErrorPage status={404} isNested />
      </PageLayout>
    );
  }

  return <HttpErrorPage status={404} isNested={false} />;
};
